import { t } from 'i18next';
import { useAppDispatch } from '../../../hook/useAppDispatch';
import { useAppSelector } from '../../../hook/useAppSelector';
import { Name } from '../../../interface/response/CashRegisterDataResponse';
import { setOperatorModalOpen, setSelectedOperator } from '../../../store/slice/operator-details-slice';
import DetailsLayout from './DetailsLayout';
import { CashRegisterMode } from '../../../enum/CashRegisterMode';

interface OperatorDetailsProps {
  getDetails: (item: Name) => void;
  setShowDetails: (showDetails: boolean) => void;
}
const OperatorDetails: React.FC<OperatorDetailsProps> = ({ getDetails, setShowDetails }) => {
  const dispatch = useAppDispatch();

  const operatorDetails = useAppSelector((state) => state.operatorDetails);
  const operatorGames = useAppSelector((state) => state.operatorDetails.data?.Games);
  const operators = useAppSelector((state) => state.operatorDetails.data);

  return (
    <DetailsLayout
      className="operator_details_container"
      title={t('cashRegister.table.details.operatorDetails.header')}
      startState={operatorDetails.data && operatorDetails.data.StartState}
      endState={operatorDetails.data && operatorDetails.data.EndState}
      onClose={() => {
        dispatch(setOperatorModalOpen(false));
        dispatch(setSelectedOperator(null));
        setShowDetails(false);
      }}
      onSearch={getDetails}
      mode={CashRegisterMode.OPERATOR_DETAILS}
      aplicationGames={operatorGames || []}
      operators={operators}
      loading={operatorDetails.loading}
    />
  );
};

export default OperatorDetails;
